import { PatientDependent } from "./patientDependent";

export class PatientEmployerInfo {
  id: number;
  patientId: number;
  jobTitle: string;
  employerName: string;
  hrContactName: string;
  hrContactEmail: string;
  hrContactPhoneNumber: string;
  dependents: PatientDependent[]
}
